import { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router';
import { ErrorPage } from './error-page';

export function RouteError() {
  const error = useRouteError();
  useEffect(() => {
    console.error('Dashboard route failed', error);
  }, [error]);
  const missing = isRouteErrorResponse(error) && error.status === 404;
  return <ErrorPage missing={missing} />;
}
